import cloneDeep from 'lodash/cloneDeep';
import { AddPoint } from '../points.actions';
import { TPointsByWorkspace } from '../points.model';

export function addPoint(oldState: TPointsByWorkspace, action: AddPoint): TPointsByWorkspace {
  const state = cloneDeep(oldState);
  const { workspaceId, point } = action.payload;
  const existingEntities = state[workspaceId]?.entities ?? [];

  state[workspaceId] = {
    ...state[workspaceId],
    entities: [...existingEntities, point],
  };

  return state;
}
